import React from "react";
//components
import { Button } from "components/Button";
import { Visibility } from "components/Visibility";
import { VisibilityConditional } from "components/VisibilityConditional";
import { pedidosAction, cotacoesAction } from 'components/ApplicationInsights/eventNames';

import IconArrowUp from 'img/arrow-up.svg';
import IconArrowDown from 'img/arrow-up.svg';

//interfaces
import { IDropdownArrow } from "./interface";
import { Container } from "./styles";

export const DropdownArrow: React.FC<IDropdownArrow> = (props) => {
  const { index, data, renderButton, isRanking, colorRowTable, expandedDropdown, setExpandedDropdown } = props;

  function getTrackName() {
    if (window.location.pathname === '/cotacoes') {
      return cotacoesAction.VISUALIZARCOTACAO;
    } else if (window.location.pathname === '/pedidos') {
      return pedidosAction.VISUALIZARPEDIDO;
    } else {
      return pedidosAction.DASHBOARD_VISUALIZARPEDIDO;
    }
  }

  const renderArrowUp = () => (
    <img
      src={IconArrowUp}
      alt=""
      className='img-arrow-down img-arrow-up'
    />
  );
  const renderArrowDown = () => (
    <img
      src={IconArrowDown}
      alt=""
      className='img-arrow-down'
    />
  );

  return (
    <Container className={`${!isRanking && colorRowTable!(index)}`}>
      <Button
        key={index}
        trackName={getTrackName()}
        onClick={() =>
          setExpandedDropdown!((old) =>
            old !== index ? index : undefined
          )
        }
        className="no-style"
      >
        <VisibilityConditional
          key={index}
          condition={expandedDropdown === index}
          firstOption={() => renderArrowUp()}
          secondOption={() => renderArrowDown()}
        />
      </Button>
      <Visibility visible={data[index].viewList}>
        {renderButton!(data[index])}
      </Visibility>
    </Container>
  );
};